import * as DataFormat from '../../../../../Common/Scripts';

const ScriptAllocation = () => [
	{
		dataField: 'qualificationYear',
		text: 'Year',
		editable: false,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'type',
		text: 'Type',
		editable: false,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{ dataField: 'markingTeamId', text: 'Marking Team ID', hidden: true },
	{
		dataField: 'title',
		text: 'Marking Team Title',
		sort: true,
		editable: false,
		headerClasses: 'th-title-td'
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		editable: false,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'minRange',
		text: 'Min Alloc',
		sort: true,
		editable: false,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'maxRange',
		text: 'Max Alloc',
		sort: true,
		editable: false,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide'
	}
];

export default ScriptAllocation;
